import { verify } from 'crypto';
import {
  FETCH_HOME_PAGE_DATA,
  FETCH_HOME_PAGE_DATA_SUCCESS,
  FETCH_HOME_PAGE_DATA_FAILS,
  FETCH_SEARCH_ITEMS,
  FETCH_SEARCH_ITEMS_SUCCESS,
  FETCH_SEARCH_ITEMS_FAILS,
  FETCH_LOCATION,
  FETCH_LOCATION_SUCCESS,
  FETCH_LOCATION_FAILS,
  POST_VENUE_VALUE,
  SUBMIT_SUBSCRIBER_DETAILS,
  SUBMIT_SUBSCRIBER_DETAILS_SUCCESS,
  SUBMIT_SUBSCRIBER_DETAILS_FAILS,
  CLEAR_SUBSCRIBER_DETAILS,
  CLEAR_SUBSCRIBER_DETAILS_SUCCESS,
  FETCH_PLACE_LAT_LONG,
  FETCH_PLACE_LAT_LONG_SUCCESS,
  FETCH_PLACE_LAT_LONG_FAILS,
  FETCH_SEARCH_AUTO_COMPLETE_DATA,
  FETCH_SEARCH_AUTO_COMPLETE_DATA_SUCCESS,
  FETCH_SEARCH_AUTO_COMPLETE_DATA_FAILS,
  UPDATE_COUNTRY_LONG_CODE,
  CLEAR_SEARCH_AUTO_COMPLETE_DATA,
  FETCH_META_DATA_SUCCESS,
  FETCH_META_DATA_FAILS,
  FETCH_OBJECT_HOME_OBJ_DATA,
  FETCH_OBJECT_HOME_OBJ_DATA_SUCCESS,
  FETCH_OBJECT_HOME_OBJ_DATA_FAILS,
  FETCH_SUPER_DEALS_REQUEST,
  FETCH_SUPER_DEALS_SUCCESS,
  FETCH_SUPER_DEALS_FAILURE,
  FETCH_REVIEW_SPACE_DETAILS_REQUEST,
  FETCH_REVIEW_SPACE_DETAILS_SUCCESS,
  FETCH_REVIEW_SPACE_DETAILS_FAILURE,
  SUBMIT_REVIEW_REQUEST,
  SUBMIT_REVIEW_SUCCESS,
  SUBMIT_REVIEW_FAILURE,
  CLEAR_REVIEW_SUBMISSION,
  VERIFY_REVIEW_FAILURE,
  VERIFY_REVIEW_SUCCESS,
  VERIFY_REVIEW_REQUEST,
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
  FETCH_BLOG_BY_SLUG_REQUEST,
  FETCH_BLOG_BY_SLUG_SUCCESS,
  FETCH_BLOG_BY_SLUG_FAILURE,
  INCREMENT_BLOG_VIEW_REQUEST,
  INCREMENT_BLOG_VIEW_SUCCESS,
  INCREMENT_BLOG_VIEW_FAILURE
} from '../../redux/actionTypes';
import { updateHomeDataObject, updateHomePageDataObj } from '../SpaceListing/Common/Common';
import {
  FETCH_PROMO_CODE_UPDATE,
  FETCH_PROMO_CODE_UPDATE_FAILS,
  FETCH_PROMO_CODE_UPDATE_SUCCESS,
  PROMO_CODE_UPDATE,
  PROMO_CODE_UPDATE_FAILS,
  PROMO_CODE_UPDATE_SUCCESS,
  GET_CITY,
  GET_CITY_FAILS
} from './HomeConstant';

export const spaceReducer = (
  state = {
    fetching: false,
    error: { status: false, message: '' },
    data: [],
    superDealsData: [],
    search: {
      activity: null,
      venue: null,
      address: null,
      eventType: '',
      spaceCategory: '',
    },
    reviewDetails: {
      data: null,
      isLoading: false,
      error: null
    },
    reviewSubmission: {
      isSubmitting: false,
      success: false,
      message: null,
      error: null
    },
    verifyReview: {
      isVerifying: false,
      isValid: false,
      error: null
    },
    blogs: {
      data: [],
      totalCount: 0,
      currentPage: 1,
      totalPages: 1,
      isLoading: true,
      error: null
    },
    currentBlog: {
      data: null,
      isLoading: true,
      error: null
    },
  },
  action
) => {
  switch (action.type) {
    case POST_VENUE_VALUE:
      return {
        ...state,
        search: {
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload,
        },
      };

    case FETCH_SEARCH_ITEMS:
      return Object.assign({}, state, { fetching: true });

    case FETCH_SEARCH_ITEMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        searchItems: {
          data: action.payload,
        },
      };

    case FETCH_SEARCH_ITEMS_FAILS:
      return Object.assign({}, { data: [] }, { fetching: false }, { error: { status: true, message: '' } });

    case FETCH_LOCATION:
      return Object.assign({}, state, { fetching: true });

    case FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        fetching: false,
        location: {
          data: action.payload,
        },
      };
    case FETCH_LOCATION_FAILS:
      return Object.assign({}, { data: [] }, { fetching: false }, { error: { status: true, message: '' } });

    case FETCH_HOME_PAGE_DATA:
      return Object.assign({}, state, {
        fetching: true,
        homePageData: [],
        superDealsData: [],
        homepage: {
          ...state.homepage,
          fetching: true,
          // Keep prior CMS data so a market switch / reload cannot trap the hero on PageLoader
          // if the next HOME_CONFIG request is slow or fails.
          error: { status: false, message: '' },
        },
      });

    case FETCH_HOME_PAGE_DATA_SUCCESS:
      //Training activity removed temporarily
      action.payload.spaceActivities = action?.payload?.spaceActivities?.filter((category) => category.name !== 'Train') || [];
      return {
        ...state,
        fetching: false,
        homepage: {
          ...state.homepage,
          fetching: false,
          data: action.payload,
          error: { status: false, message: '' },
        },
        homePageData: [],
      };

    case FETCH_HOME_PAGE_DATA_FAILS:
      return {
        ...state,
        fetching: false,
        homepage: {
          ...state.homepage,
          fetching: false,
          // Empty config lets BackgroundArea render defaults instead of spinning forever.
          data: state.homepage?.data || {
            config: {
              sections: [],
              customConfig: {},
              title: {},
              description: {},
            },
          },
          error: { status: true, message: action.payload?.message || '' },
        },
      };

    case FETCH_OBJECT_HOME_OBJ_DATA:
      return Object.assign({}, state, { fetching: true });

    case FETCH_OBJECT_HOME_OBJ_DATA_SUCCESS:
      return {
        ...state,
        fetching: false,
        homePageData: updateHomeDataObject(state, action),
      };

    case FETCH_OBJECT_HOME_OBJ_DATA_FAILS:
      return Object.assign({}, state, { fetching: false, error: { status: true, message: '' } });

    case SUBMIT_SUBSCRIBER_DETAILS:
      return {
        ...state,
        subscriberDetails: {
          ...state.subscriberDetails,
          fetching: true,
          subscriberDetails_error: null,
          subscriberDetails: null,
          success: false,
        },
      };
    case SUBMIT_SUBSCRIBER_DETAILS_SUCCESS:
      return {
        ...state,
        subscriberDetails: {
          ...state.subscriberDetails,
          fetching: false,
          subscriberDetails_error: null,
          subscriberDetails: action.payload,
          success: true,
        },
      };
    case SUBMIT_SUBSCRIBER_DETAILS_FAILS:
      return {
        ...state,
        subscriberDetails: {
          ...state.subscriberDetails,
          fetching: false,
          subscriberDetails_error: action.payload.response,
          subscriberDetails: null,
          success: false,
        },
      };

    case FETCH_PLACE_LAT_LONG:
      return {
        ...state,
        placeLatLng: {
          fetching: true,
          error: { status: false, message: '' },
          data: null,
        },
      };
    case FETCH_PLACE_LAT_LONG_SUCCESS:
      return {
        ...state,
        placeLatLng: {
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload,
        },
      };
    case FETCH_PLACE_LAT_LONG_FAILS:
      return {
        ...state,
        placeLatLng: {
          fetching: false,
          error: { status: false, message: action.payload?.response?.message },
          data: null,
        },
      };

    case PROMO_CODE_UPDATE:
      return {
        ...state,
        promoCodeUpdateRes: {
          fetching: true,
          error: { status: false, message: '' },
          data: null,
        },
      };
    case PROMO_CODE_UPDATE_SUCCESS:
      return {
        ...state,
        promoCodeUpdateRes: {
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload,
        },
      };
    case PROMO_CODE_UPDATE_FAILS:
      return {
        ...state,
        promoCodeUpdateRes: {
          fetching: false,
          error: { status: false, message: action.payload?.response?.message },
          data: null,
        },
      };

    case FETCH_PROMO_CODE_UPDATE:
      return {
        ...state,
        promoCode: {
          fetching: true,
          error: { status: false, message: '' },
          data: null,
        },
      };
    case FETCH_PROMO_CODE_UPDATE_SUCCESS:
      return {
        ...state,
        promoCode: {
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload,
        },
      };
    case FETCH_PROMO_CODE_UPDATE_FAILS:
      return {
        ...state,
        promoCode: {
          fetching: false,
          error: { status: false, message: action.payload?.response?.message },
          data: null,
        },
      };

    case CLEAR_SUBSCRIBER_DETAILS:
      return {
        ...state,
        subscriberDetails: {
          ...state.subscriberDetails,
          fetching: false,
          subscriberDetails_error: null,
          subscriberDetails: null,
          success: false,
        },
      };
    case CLEAR_SUBSCRIBER_DETAILS_SUCCESS:
      return {
        ...state,
        subscriberDetails: {
          ...state.subscriberDetails,
          fetching: false,
          subscriberDetails_error: null,
          subscriberDetails: null,
          success: false,
        },
      };

    case FETCH_SEARCH_AUTO_COMPLETE_DATA:
      return {
        ...state,
        autocompleteSuggestions: {
          ...state.autocompleteSuggestions,
          fetching: true,
          error: { status: false, message: '' },
        },
      };
    case FETCH_SEARCH_AUTO_COMPLETE_DATA_SUCCESS:
      return {
        ...state,
        autocompleteSuggestions: {
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload,
        },
      };
    case FETCH_SEARCH_AUTO_COMPLETE_DATA_FAILS:
      return {
        ...state,
        autocompleteSuggestions: {
          ...state.autocompleteSuggestions,
          fetching: false,
          error: { status: false, message: action.payload?.response?.message },
        },
      };
    case CLEAR_SEARCH_AUTO_COMPLETE_DATA:
      return {
        ...state,
        autocompleteSuggestions: {
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload,
        },
      };
    case FETCH_META_DATA_FAILS:
      return {
        ...state,
        error: { status: false, message: '' },
        fetchingMeta: false,
      };
    case FETCH_META_DATA_SUCCESS:
      return {
        ...state,
        fetchingMeta: true,
        data: action.payload,
      };
    case UPDATE_COUNTRY_LONG_CODE:
      return {
        ...state,
        searchCountry: action.payload,
      };
    case GET_CITY:
      return {
        ...state,
        city: action.payload,
      };

      //super deals
    case FETCH_SUPER_DEALS_REQUEST:
      return {
        ...state,
        superDealsData: [],
        fetching: true,
        error: { status: false, message: '' }
      };
    case FETCH_SUPER_DEALS_SUCCESS:
      return {
        ...state,
        fetching: false,
        superDealsData: action.payload,
        error: { status: false, message: '' }
      };
    case FETCH_SUPER_DEALS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: { status: true, message: action.error?.message || 'Failed to fetch super deals' }
      };

      //review start
      case FETCH_REVIEW_SPACE_DETAILS_REQUEST:
      return {
        ...state,
        reviewDetails: {
          ...state.reviewDetails,
          isLoading: true,
          error: null
        }
      };

    case FETCH_REVIEW_SPACE_DETAILS_SUCCESS:
      return {
        ...state,
        reviewDetails: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case FETCH_REVIEW_SPACE_DETAILS_FAILURE:
      return {
        ...state,
        reviewDetails: {
          data: null,
          isLoading: false,
          error: action.payload
        }
      };

    case SUBMIT_REVIEW_REQUEST:
      return {
        ...state,
        reviewSubmission: {
          isSubmitting: true,
          success: false,
          message: null,
          error: null
        }
      };

    case SUBMIT_REVIEW_SUCCESS:
      return {
        ...state,
        reviewSubmission: {
          isSubmitting: false,
          success: true,
          message: action.payload,
          error: null
        }
      };

    case SUBMIT_REVIEW_FAILURE:
      return {
        ...state,
        reviewSubmission: {
          isSubmitting: false,
          success: false,
          message: null,
          error: action.payload
        }
      };

    case CLEAR_REVIEW_SUBMISSION:
      return {
        ...state,
        reviewSubmission: {
          isSubmitting: false,
          success: false,
          message: null,
          error: null
        }
      };

      case VERIFY_REVIEW_REQUEST:
      return {
        ...state,
        verifyReview: {
          isVerifying: true,
          isValid: false,
          error: null
        }
      };
    case VERIFY_REVIEW_SUCCESS:
      return {
        ...state,
        verifyReview: {
          isVerifying: false,
          isValid: true,
          error: null
        }
      };
    case VERIFY_REVIEW_FAILURE:
      return {
        ...state,
        verifyReview: {
          isVerifying: false,
          isValid: false,
          error: action.payload
        }
      };

    // Blog cases
    case FETCH_BLOGS_REQUEST:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          isLoading: true,
          error: null
        }
      };

    case FETCH_BLOGS_SUCCESS:
      return {
        ...state,
        blogs: {
          data: action.payload.content || action.payload.data || action.payload,
          totalCount: action.payload.totalElements || action.payload.totalCount || 0,
          currentPage: (action.payload.number !== undefined ? action.payload.number + 1 : action.payload.currentPage) || 1,
          totalPages: action.payload.totalPages || 1,
          isLoading: false,
          error: null
        }
      };

    case FETCH_BLOGS_FAILURE:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          isLoading: false,
          error: action.payload
        }
      };

    case FETCH_BLOG_BY_SLUG_REQUEST:
      return {
        ...state,
        currentBlog: {
          data: null,
          isLoading: true,
          error: null
        }
      };

    case FETCH_BLOG_BY_SLUG_SUCCESS:
      return {
        ...state,
        currentBlog: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case FETCH_BLOG_BY_SLUG_FAILURE:
      return {
        ...state,
        currentBlog: {
          data: null,
          isLoading: false,
          error: action.payload
        }
      };

    // Increment blog view count
    case INCREMENT_BLOG_VIEW_SUCCESS:
      return {
        ...state,
        currentBlog: {
          ...state.currentBlog,
          data: state.currentBlog.data ? {
            ...state.currentBlog.data,
            viewCount: (state.currentBlog.data.viewCount || 0) + 1
          } : state.currentBlog.data
        }
      };

    case INCREMENT_BLOG_VIEW_REQUEST:
    case INCREMENT_BLOG_VIEW_FAILURE:
      // Do nothing - view count increment is not critical
      return state;

    default:
      return state;
  }
};
